import {
	USERS_SUCCESS,
	USERS_FAILURE,
	USERS_LOADING,
	USERS_UPDATING_SUCCESS,
	RESET_USERS_UPDATING_SUCCESS,
	USERS_UPDATING_FAILURE,
	USERS_UPDATING,
	USERS_DELETING,
	USERS_DELETING_FAILURE,
	USERS_DELETING_SUCCESS,
	RESET_USERS_DELETING_SUCCESS,
	ME_LOADING,
	ME_SUCCESS,
	ME_FAILURE,
	JOINING_TEAM,
	JOIN_TEAM_SUCCESS,
	JOIN_TEAM_FAILURE,
	AWARDS_LOADING,
	AWARDS_LOADING_FAILURE,
	AWARDS_LOADING_SUCCESS,
	UPDATE_SELECTED_TEAM,
	TOGGLING_FAVORITE_TEAM,
	TOGGLING_FAVORITE_TEAM_SUCCESS,
	TOGGLING_FAVORITE_TEAM_FAILURE,
	LEAVING_TEAM,
	LEAVE_TEAM_FAILURE,
	LEAVE_TEAM_SUCCESS,
	NEW_TEAM_VISITED,
	SENDING_FEEDBACK,
	SEND_FEEDBACK_FAILURE,
	SEND_FEEDBACK_SUCCESS,
	RESET_SEND_FEEDBACK_SUCCESS,
	ACCEPTING_EULA,
	ACCEPT_EULA_SUCCESS,
	ACCEPT_EULA_FAILURE,
	RESET_ACCEPT_EULA_SUCCESS,
	TOGGLE_ALL_NOTIFICATIONS,
	TOGGLE_ALL_NOTIFICATIONS_FAILURE,
	TOGGLE_ALL_NOTIFICATIONS_SUCCESS,
	RESET_TOGGLE_ALL_NOTIFICATIONS_SUCCESS,
	TOGGLE_PERSONAL_NOTIFICATIONS,
	TOGGLE_PERSONAL_NOTIFICATIONS_FAILURE,
	TOGGLE_PERSONAL_NOTIFICATIONS_SUCCESS,
	RESET_TOGGLE_PERSONAL_NOTIFICATIONS_SUCCESS,
	TEAM_SEASONS_LOADING,
	TEAM_SEASONS_SUCCESS,
	TEAM_SEASONS_FAILURE,
	TOUR_FAILURE,
	TOUR_SAVING,
	TOUR_SUCCESS,
	RESET_TOUR_SUCCESS,
	DELETING_TOURS,
	DELETE_TOURS_SUCCESS,
	RESET_DELETE_TOURS_SUCCESS,
	DELETE_TOURS_FAILURE
} from 'redux/reduxConstants';
import { UserTeams } from 'redux/models/userTeams';
import { TeamUsers } from 'redux/models/teamUsers';
import { Team } from 'redux/models/team';
import { Season } from 'redux/models/season';

export function usersLoading() {
	return { type: USERS_LOADING };
}

export function usersSuccess(users: TeamUsers[]) {
	return { type: USERS_SUCCESS, users };
}

export function usersFailure(error: string) {
	return { type: USERS_FAILURE, error };
}

export function usersUpdating() {
	return { type: USERS_UPDATING };
}

export function usersUpdatingSuccess(users: TeamUsers[]) {
	return { type: USERS_UPDATING_SUCCESS, users };
}

export function usersUpdatingFailure(error: string) {
	return { type: USERS_UPDATING_FAILURE, error };
}

export function resetUsersUpdatingSuccess() {
	return { type: RESET_USERS_UPDATING_SUCCESS };
}

export function usersDeleting() {
	return { type: USERS_DELETING };
}

export function usersDeletingSuccess(userIds: string[]) {
	return { type: USERS_DELETING_SUCCESS, userIds };
}

export function usersDeletingFailure(error: string) {
	return { type: USERS_DELETING_FAILURE, error };
}

export function resetUsersDeletingSuccess() {
	return { type: RESET_USERS_DELETING_SUCCESS };
}

export function meLoading() {
	return { type: ME_LOADING };
}

export function meSuccess(userTeams: UserTeams) {
	return { type: ME_SUCCESS, userTeams };
}

export function meFailure(error: string) {
	return { type: ME_FAILURE, error };
}

export function joiningTeam(teamId: string) {
	return { type: JOINING_TEAM, teamId };
}

export function joinTeamSuccess(userTeams: UserTeams) {
	return { type: JOIN_TEAM_SUCCESS, userTeams };
}

export function joinTeamFailure(error: string) {
	return { type: JOIN_TEAM_FAILURE, error };
}

export function awardsLoading() {
	return { type: AWARDS_LOADING };
}

export function awardsLoadingSuccess(userTokens: any[]) {
	return { type: AWARDS_LOADING_SUCCESS, userTokens };
}

export function awardsLoadingFailure(error: string) {
	return { type: AWARDS_LOADING_FAILURE, error };
}

export function leavingTeam() {
	return { type: LEAVING_TEAM };
}

export function leaveTeamSuccess(leftTeamId: string) {
	return { type: LEAVE_TEAM_SUCCESS, leftTeamId };
}

export function leaveTeamFailure(error: string) {
	return { type: LEAVE_TEAM_FAILURE, error };
}

export function updateSelectedTeam(teamId: string) {
	return { type: UPDATE_SELECTED_TEAM, teamId };
}

export function togglingFavoriteTeam() {
	return { type: TOGGLING_FAVORITE_TEAM };
}

export function togglingFavoriteTeamSuccess(team: Team) {
	return { type: TOGGLING_FAVORITE_TEAM_SUCCESS, team };
}

export function togglingFavoriteTeamFailure(error: string) {
	return { type: TOGGLING_FAVORITE_TEAM_FAILURE, error };
}

export function newTeamVisitedAction() {
	return { type: NEW_TEAM_VISITED };
}

export function sendingFeedback() {
	return { type: SENDING_FEEDBACK };
}

export function sendFeedbackSuccess() {
	return { type: SEND_FEEDBACK_SUCCESS };
}

export function sendFeedbackFailure(error: string) {
	return { type: SEND_FEEDBACK_FAILURE, error };
}

export function resetSendFeedbackSuccess() {
	return { type: RESET_SEND_FEEDBACK_SUCCESS };
}

export function acceptingEula() {
	return { type: ACCEPTING_EULA };
}

export function acceptEulaSuccess() {
	return { type: ACCEPT_EULA_SUCCESS };
}

export function accpetEulaFailure(error: string) {
	return { type: ACCEPT_EULA_FAILURE, error };
}

export function resetAcceptEulaSuccess() {
	return { type: RESET_ACCEPT_EULA_SUCCESS };
}

export function toggleAllNotifications() {
	return { type: TOGGLE_ALL_NOTIFICATIONS };
}

export function toggleAllNotificationsSuccess(team: Team) {
	return { type: TOGGLE_ALL_NOTIFICATIONS_SUCCESS, team };
}

export function toggleAllNotificationsFailure(error: string) {
	return { type: TOGGLE_ALL_NOTIFICATIONS_FAILURE, error };
}

export function resetToggleAllNotifications() {
	return { type: RESET_TOGGLE_ALL_NOTIFICATIONS_SUCCESS };
}

export function togglePersonalNotifications() {
	return { type: TOGGLE_PERSONAL_NOTIFICATIONS };
}

export function togglePersonalNotificationsSuccess(team: Team) {
	return { type: TOGGLE_PERSONAL_NOTIFICATIONS_SUCCESS, team };
}

export function togglePersonalNotificationsFailure(error: string) {
	return { type: TOGGLE_PERSONAL_NOTIFICATIONS_FAILURE, error };
}

export function resetTogglePersonalNotifications() {
	return { type: RESET_TOGGLE_PERSONAL_NOTIFICATIONS_SUCCESS };
}

export function teamSeasonsLoading() {
	return { type: TEAM_SEASONS_LOADING };
}

export function teamSeasonsSuccess(seasons: Season[]) {
	return { type: TEAM_SEASONS_SUCCESS, seasons };
}

export function teamSeasonsFailure(error: string) {
	return { type: TEAM_SEASONS_FAILURE, error };
}

export function tourSaving() {
	return { type: TOUR_SAVING };
}

export function tourSuccess(tourName: string) {
	return { type: TOUR_SUCCESS, tourName };
}

export function tourFailure(error: string) {
	return { type: TOUR_FAILURE, error };
}

export function resetTourSuccess() {
	return { type: RESET_TOUR_SUCCESS };
}

export function deleteTours() {
	return { type: DELETING_TOURS };
}

export function deleteToursSuccess() {
	return { type: DELETE_TOURS_SUCCESS };
}

export function deleteToursFailure(error: string) {
	return { type: DELETE_TOURS_FAILURE, error };
}

export function resetDeleteToursSuccess() {
	return { type: RESET_DELETE_TOURS_SUCCESS };
}
